import { ArrowRight, CheckCircle2, Circle, UserRound } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components/ui/Button'
import { PageHeader } from '../../components/ui/PageHeader'
import { LEARNING_TASKS } from '../../data/dashboardData'
import { useAppState } from '../../state/AppState'

export function ParentPage() {
  const navigate = useNavigate()
  const { completedTaskIds } = useAppState()

  return (
    <div className="content-page">
      <PageHeader
        title="家长视图"
        description="每周只看关键变化、主要风险和下一步行动。"
      />

      <section className="parent-summary">
        <div className="parent-summary__heading">
          <span aria-hidden="true">
            <UserRound size={25} strokeWidth={1.6} />
          </span>
          <div>
            <h2>本周家长报告尚未生成</h2>
            <p>当前处于入学准备阶段，先完成档案、诊断和首周计划。</p>
          </div>
        </div>

        <div className="parent-checklist">
          {LEARNING_TASKS.map((task) => {
            const isComplete = completedTaskIds.has(task.id)
            return (
              <div key={task.id}>
                {isComplete ? (
                  <CheckCircle2 size={19} aria-hidden="true" />
                ) : (
                  <Circle size={19} aria-hidden="true" />
                )}
                <span>{task.title}</span>
                <strong>{isComplete ? '已完成' : '待完成'}</strong>
              </div>
            )
          })}
        </div>

        <div className="parent-guidance">
          <h3>家长当前只需要做三件事</h3>
          <ol>
            <li>确认学校使用的高一数学教材版本。</li>
            <li>上传最近数学试卷、暑假作业和可用时间。</li>
            <li>为诊断预留一段不被打扰的 40 分钟。</li>
          </ol>
        </div>

        <Button onClick={() => navigate('/materials')}>
          前往资料库
          <ArrowRight size={17} aria-hidden="true" />
        </Button>
      </section>
    </div>
  )
}
